import { GQL } from "@binale-tech/shared";

export type AutoSortSummary = {
    er: number;
    deb: number;
    bank: number;
    linked: number;
    kb: number;
    remaining: number;
    skipped: number;
    failed: number;
    moved: number;
};

export const summarizeAutoSort = (results: GQL.IDmsAutoSortResult[]): AutoSortSummary => {
    const summary: AutoSortSummary = {
        er: 0,
        deb: 0,
        bank: 0,
        linked: 0,
        kb: 0,
        remaining: 0,
        skipped: 0,
        failed: 0,
        moved: 0,
    };
    for (const { outcome, reason, transactionId } of results) {
        switch (outcome) {
            case GQL.IDmsAutoSortOutcome.MovedEr:
                summary.er += 1;
                break;
            case GQL.IDmsAutoSortOutcome.MovedDeb:
                summary.deb += 1;
                break;
            case GQL.IDmsAutoSortOutcome.MovedBank:
                summary.bank += 1;
                if (transactionId) {
                    summary.linked += 1;
                }
                break;
            case GQL.IDmsAutoSortOutcome.MovedKb:
                summary.kb += 1;
                break;
            default:
                if (reason === GQL.IDmsAutoSortReason.Error) {
                    summary.failed += 1;
                } else if (reason === GQL.IDmsAutoSortReason.NotInNewDocuments) {
                    summary.skipped += 1;
                } else {
                    summary.remaining += 1;
                }
        }
    }
    summary.moved = summary.er + summary.deb + summary.bank + summary.kb;
    return summary;
};
